import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useHorse } from '../../hooks/useHorse';
import { toNumber } from 'lodash';
import Header from '../../components/dashboard/Header';
import TrackViewSkeleton from '../../components/tracks/TrackViewSkeleton';
import { Box, Button, Divider } from '@mui/material';
import NotFound from '../../components/global/NotFound';
import HorseView from '../../components/horse/HorseView';
import { t } from 'i18next';
import { Edit } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Icon } from '@iconify/react';
import { useDispatch } from 'react-redux';
import { restModalsToInitialState, setHorseModal, setHorseToEdit } from '../../store/reducers/modal.reducer';
import Page from '../../components/layout/Helmet';
import { TtrainingKeyParameterItem } from '../../shared/types/TrainingKeyParameterItem.type';
import { toast } from 'react-toastify';
import { useQueryClient } from 'react-query';
import { useAuth } from '../../hooks/useAuth';
import { isSet } from '../../shared/utils/global';
import { useExam } from '../../hooks/useExam';
import { hydraTransform } from '../../shared/utils/hydraTransformer';
import { Ttraining } from '../../shared/types/training.type';
import { useUserActivityLog } from '../../hooks/useUserActivityLog';

function Horse() {
    const [examParams, setExamParams] = useState<TtrainingKeyParameterItem[]>([])
    const queryClient = useQueryClient()
    //Get horse id from route
    let { id } = useParams();
    const { auth } = useAuth()
    const { track } = useUserActivityLog()

    //State

    const [horseTrainings, setHorseTrainings] = useState<Ttraining[]>([])
    //Hooks
    const { horse, isHorseLoading, isHorseError, updateHorseCommentMutation } = useHorse({
        enableQuery: true,
        horseId: toNumber(id),
        horseParams: ['include-max-heart-rate=true']
    })


    let userId = auth?.['@id']

    const { getHorseExams } = useExam(false, userId, null, id)


    useEffect(() => {
        track('HORSE_PAGE_DISPLAYED')
    }, [])


    useEffect(() => {
        if (!id && !userId) return
        getHorseExams.mutateAsync()
            .then(result => {
                let data = hydraTransform(result.data)
                setHorseTrainings(data)
            }).catch(err => {

            })
    }, [id, userId])


    const dispatch = useDispatch()

    //Effects
    useEffect(() => {
        dispatch(restModalsToInitialState())
    }, [])

    //Fns

    const openHorseModal = () => {
        dispatch(setHorseModal(true))
    }

    const editHorse = () => {
        dispatch(setHorseToEdit(horse ?? null))
        openHorseModal()
    }

    const updateComment = async (comment: string) => {
        try {
            if (!horse) return
            await updateHorseCommentMutation.mutateAsync({ comment, horse: horse?.['@id'] })
            toast(t('parameters:commentUpdated'), { type: 'success' })
            queryClient.refetchQueries(['horse', horse.id])
        } catch (error) {
            toast(t('error:generic'), { type: 'error' })

        }
    }

    //Conditionnal rendring

    if (isHorseLoading) {
        return <TrackViewSkeleton></TrackViewSkeleton>
    }

    if (isHorseError) {
        return <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'calc(100vh - 200px)'} >
            <NotFound></NotFound>
        </Box>
    }


    return (
        <Page title={horse?.name ?? 'horse'}>
            <Header text={horse?.name ?? 'horse'}>

                {/* Horse Actions */}
                <Box display={'flex'} gap={1} flexWrap={'wrap'} alignItems={'center'}>
                    {
                        horse?.editable && <Button onClick={editHorse} variant='outlined' startIcon={<Edit></Edit>}>{t('editHorse')}</Button>
                    }

{/*                     <LoadingButton loading={false} onClick={() => { }} startIcon={<Icon icon={'solar:file-download-linear'}></Icon>} disableElevation variant='contained'>{t('report:buttonText')}</LoadingButton>
 */}                </Box>

            </Header>

            <Divider sx={{ my: 2 }}></Divider>

            {/* Display horse infos */}

            <HorseView
                onExamParamsChanged={data => setExamParams(data)}
                examParams={examParams}
                horse={horse}
                updateComment={updateComment}
                isCommentUpdating={updateHorseCommentMutation.isLoading}
                horseExams={horseTrainings}
            />

        </Page >
    )
}

export default Horse